var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "performance-report-detail" }, [
    _c("div", { staticClass: "header" }, [_vm._v("履约报表详情")]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "detail basic-msg" }, [
        _c("div", { staticClass: "header" }, [_vm._v("基础信息")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  "tooltip-effect": "dark",
                  border: "",
                  data: _vm.resData.list
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "str_demanded_date",
                    label: "需求日期"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { align: "center", prop: "supply_id", label: "商家ID" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "str_supply",
                    label: "商家",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "str_market",
                    label: "市场",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "str_pg_group",
                    label: "代采组",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "str_pg_member",
                    label: "代采员"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail amount" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  "tooltip-effect": "dark",
                  border: "",
                  data: _vm.resData.list
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "24h_performance_rate",
                    label: "24H履约率"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { position: "relative" } },
                                [
                                  _vm._v("\n                  24H履约率"),
                                  _c("i", { staticClass: "el-icon-question" })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("div", [
                                    _vm._v(
                                      "24H履约率 = 24H已履约金额 / 总需求金额"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v("24H：履约时间-需求日期 7:00 ≤ 24H")
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("div", [
                            _c("div", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(scope.row["24h_performance_rate"]) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { color: "#ccc" } }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(scope.row["24h_generate_status"]) +
                                  "\n                "
                              )
                            ])
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "48h_performance_rate",
                    label: "48H履约率"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { position: "relative" } },
                                [
                                  _vm._v("\n                  48H履约率"),
                                  _c("i", { staticClass: "el-icon-question" })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("div", [
                                    _vm._v(
                                      "48H履约率 = 48H已履约金额 / 总需求金额"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v("48H：履约时间-需求日期 7:00 ≤ 48H")
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("div", [
                            _c("div", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(scope.row["48h_performance_rate"]) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { color: "#ccc" } }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(scope.row["48h_generate_status"]) +
                                  "\n                "
                              )
                            ])
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "final_performance_rate",
                    label: "最终履约率"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { position: "relative" } },
                                [
                                  _vm._v("\n                  最终履约率"),
                                  _c("i", { staticClass: "el-icon-question" })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("div", [
                                    _vm._v(
                                      "最终履约率 = 最终已履约金额 / 总需求金额"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "春夏（3月~9月）：履约时间 - 需求日期 7:00 ≤ 10天"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "秋冬（10月~2月）：履约时间 - 需求日期 7:00 ≤ 15天"
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("div", [
                            _c("div", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(scope.row["final_performance_rate"]) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { color: "#ccc" } }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(scope.row["final_generate_status"]) +
                                  "\n                "
                              )
                            ])
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { align: "center", label: "总需求" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_all_pre",
                        label: "前置仓发货"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v(
                                        "\n                    前置仓发货"
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_all_plan",
                        label: "订货单计划代采"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v(
                                        "\n                    订货单计划代采"
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    统计对应需求时间的代采计划中，总计划代采的商品数据。不含提前代采计划\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_all_sum",
                        label: "小计"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v("\n                    小计"),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    总需求 = 前置仓发货 + 订货单计划代采\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      align: "center",
                      label: "已履约",
                      "label-class-name": "performance"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_done_pre",
                        label: "前置仓发货",
                        "label-class-name": "performance"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v(
                                        "\n                    前置仓发货"
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_done_plan",
                        label: "订货单正常品已入库（含坏账）",
                        "label-class-name": "performance"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v(
                                        "\n                    订货单正常品已入库（含坏账）"
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    统计对应需求时间的代采计划，开单后售前首次以正常品入库 或\n                    首次申请为坏账时计入。\n                    ①恢复欠货/正常品入库后调拨为不良品/坏账驳回均不再扣除。\n                    ②已计入履约的，不再重复计算。\n                    ③履约时间：代采欠货正常品入库-取生成包裹时间；退换货欠货正常品入库\n                    -取入库时间；申请坏账 - 申请坏账时间\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_done_sum",
                        label: "小计",
                        "label-class-name": "performance"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v("\n                    小计"),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    已履约 = 前置仓发货 + 订货单正常品已入库（含坏账）\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      align: "center",
                      label: "待履约",
                      "label-class-name": "await-performance"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_doing_plan",
                        label: "待开单",
                        "label-class-name": "await-performance"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v("\n                    待开单"),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    统计对应需求时间的代采计划当前在待开单的商品数据。\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_doing_owe",
                        label: "订单欠货",
                        "label-class-name": "await-performance"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v("\n                    订单欠货"),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    统计对应需求时间的代采计划当前在订单欠货（含由订单欠货转退款中）的商品数据。\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_doing_on_way",
                        label: "配送在途",
                        "label-class-name": "await-performance"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v("\n                    配送在途"),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    统计对应需求时间的代采计划当前在配送在途（即在途库存）、在途转欠货申请中的商品数据。\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_doing_reject",
                        label: "退换货",
                        "label-class-name": "await-performance"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v("\n                    退换货"),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    统计对应需求时间的代采计划当前为售前不良品在库、退换货待接收、退换货欠货、由售前退换货转退款中和转呆账的商品数据。\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_doing_sum",
                        label: "小计",
                        "label-class-name": "await-performance"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v("\n                    小计"),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    待履约 = 待开单 + 订单欠货 + 配送在途 + 退换货\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      align: "center",
                      label: "未履约",
                      "label-class-name": "default"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_yet_stopped",
                        label: "已断货",
                        "label-class-name": "default"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v("\n                    已断货"),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    统计对应需求时间的代采计划当前已断货的商品数据。\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_yet_ded",
                        label: "转抵扣",
                        "label-class-name": "default"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v("\n                    转抵扣"),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    统计对应需求时间的代采计划当前已转抵扣（含待抵扣、已抵扣、待抵扣转退款中）的商品数据。\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_yet_refund",
                        label: "已退款",
                        "label-class-name": "default"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v("\n                    已退款"),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    统计对应需求时间的代采计划当前已完成退款的商品数据。\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "str_yet_sum",
                        label: "小计",
                        "label-class-name": "default"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { position: "relative" } },
                                    [
                                      _vm._v("\n                    小计"),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "未履约 = 已断货 + 转抵扣 + 已退款"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail amount" }, [
        _c("div", { staticClass: "header" }, [_vm._v("商品明细")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "el-tabs",
              {
                attrs: { stretch: true },
                on: { "tab-click": _vm.handleClickTag },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              _vm._l(_vm.resData.options_report_detail_type, function(item) {
                return _c("el-tab-pane", {
                  key: item.value,
                  attrs: { label: item.label, name: item.value }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("YsDataTable", {
              ref: "tableRef",
              attrs: {
                "init-params": _vm.initParams,
                list: _vm.searchList,
                "dep-option-map": _vm.optionsMap,
                columns: _vm.columns,
                "fetch-method": _vm.fetchMethod,
                "page-size-alias": "page_size",
                "button-list": _vm.buttonList,
                "use-data-field": ""
              },
              on: {
                "on-change": _vm.getSearchParams,
                "on-fetch-success": _vm.handleFetchSuccess
              },
              scopedSlots: _vm._u([
                {
                  key: "table-title",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "header" }, [
                        _vm._v(
                          "\n              数据列表 共" +
                            _vm._s(_vm.goodsDetailAmount.sum_num) +
                            "件，计￥" +
                            _vm._s(_vm.goodsDetailAmount.sum_price) +
                            "元\n            "
                        )
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "goods_img",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "goods-img",
                          on: {
                            click: function($event) {
                              return _vm.handleViewImages([row.goods_img])
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticStyle: {
                              "max-width": "100%",
                              "max-height": "100%",
                              "object-fit": "cover"
                            },
                            attrs: { src: row.goods_img }
                          })
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "wcgPlan",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("div", { staticClass: "wcg-plan" }, [
                        _c("span", { staticClass: "wcg_plan_id" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(row.planid) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ptype" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(row.ptype) +
                              "\n                "
                          ),
                          row.is_dispense
                            ? _c(
                                "span",
                                { staticStyle: { color: "#479ce8" } },
                                [
                                  _vm._v(
                                    "\n                  （ 小店分发）\n                "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "effect-time" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(row.effect_time) +
                              "\n              "
                          )
                        ])
                      ])
                    ]
                  }
                },
                {
                  key: "wcgOrder",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("div", { staticClass: "wcg-plan" }, [
                        _c("span", { staticClass: "woid" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(row.woid) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "wcg-sub-time" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(row.wcg_sub_time) +
                              "\n              "
                          )
                        ])
                      ])
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.refresh,
                callback: function($$v) {
                  _vm.refresh = $$v
                },
                expression: "refresh"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _vm._v("\n        报表汇总\n        "),
      _c("span", { staticStyle: { color: "#4e9fe8" } }, [
        _vm._v("\n          （数量/金额，金额按计划代采单统计）\n        ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09377c56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09377c56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PerformanceReport/PerformanceReportDetail.vue
// module id = null
// module chunks = 